/* eslint-disable no-console */

import { register } from "register-service-worker"

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      )
    },
    registered(registration) {
      console.log("Service worker has been registered.")
    },
    cached() {
      console.log("Content has been cached for offline use.")
    },
    updatefound(registration) {
      console.log("New content is downloading.")
    },
    updated(registration) {
      try {
        const waiting = registration && registration.waiting;
        if (waiting && typeof waiting.postMessage === 'function') {
          // Tell the waiting service worker to skip waiting so the new cache is used
          waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      } catch (e) {
        // Swallow errors to avoid disrupting the app
        console.error('SW skipWaiting failed:', e);
      }
      if (Vue && Vue.$store) {
        Vue.$store.commit('updateWorker', registration.waiting)
      }
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      )
    },
    error(error) {
      console.error("Error during service worker registration:", error)
    },
  })

  // Ensure files from the new cache are used when the service worker changes
  let refreshing
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener("controllerchange", e => {
      if (refreshing) return // Avoid infinite refreshing
      refreshing = true
      window.location.reload()
    })
  }
}
